import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate, Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import "./Mainheader.scss";
import NavDropdown from "react-bootstrap/NavDropdown";
import PhnIcon from "../../assets/images/PhnIcon.svg";
import EMailIcon from "../../assets/images/EMailIcon.svg";
import Image from "react-bootstrap/Image";

import { getAllLanguages, getMailProductCity } from "../../api/apiRequest";
import { NotificationManager } from "react-notifications";
import { useLangContext } from "../../context/languageContext";

import { useTranslation } from "react-i18next";

const Mainheader = () => {
  const { t } = useTranslation(["common","navbar"]);
  const navigate = useNavigate();
  const { hostLanguage, setHostLanguage, changeLanguage } = useLangContext();
  let userData = JSON.parse(localStorage.getItem("virtualOfficeLoginInfo"));
  const [language, setLanguage] = useState([]);

  const [cities,setCities] = useState([]);
  const fetchMailProductCity = async(product_id) => {
      try
      {
        let apiRes = await getMailProductCity(product_id);
        let responseData = await apiRes.json();
        if(responseData.res)
        {
          setCities(Object.values(responseData.data).flat());
        }
        else
        {
          NotificationManager.error(responseData.msg,'',2000);
        }
      }
      catch(error)
      {
        console.error(error);
      }
  }

  const getLanguages = async () => {
    let apiRes = await getAllLanguages();
    let responseData = await apiRes.json();

    if (responseData.res) {
      setLanguage(responseData.data);
    } else {
      NotificationManager.error(responseData.msg, "", 2000);
    }
  };

  useEffect(() => {
    getLanguages();
    fetchMailProductCity(1);
  }, []);

  return (
    <div id="WebHeader">
      <Navbar expand="xl" className="MainHr">
        <Container fluid className="MainHrContainer">
          <Navbar.Brand href="/">
            <img src="/images/cleverdomizil-logo.webp" className="MainLogo" alt={t('navbar:logo')}/>
          </Navbar.Brand>

          <div className="MainHrLft">
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="MainHrLftMenu">
                <NavDropdown
                  title={t('navbar:link_1')}
                  id="basic-nav-dropdown"
                  className="MenuDrp"
                >
                  <NavDropdown.Item as={Link} to="/geschaeftsadresse">
                    {" "}
                    <Image src={EMailIcon} className="PhoneBig" alt="PhoneBig" />
                    {t('navbar:link_1_dropdown_1')}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/telefonnummer">
                    {" "}
                    <Image src={PhnIcon} className="PhoneBig" alt="PhoneBig" />
                    {t('navbar:link_1_dropdown_2')}
                  </NavDropdown.Item>
                </NavDropdown>

                <NavDropdown
                  title={t('navbar:link_2')}
                  id="basic-nav-dropdown"
                  className="MenuDrp"
                >
                  <NavDropdown.Item as={Link} to="/leistungen/steuer-und-buchhaltungsservice">
                    {" "}
                    {t('navbar:link_2_dropdown_1')}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/leistungen/gruendungsservice">
                    {" "}
                    {t('navbar:link_2_dropdown_2')}
                  </NavDropdown.Item>
                </NavDropdown>

                <NavDropdown
                  title={t('navbar:link_3')}
                  id="basic-nav-dropdown"
                  className="MenuDrp"
                >
                  {cities?.map((item,index)=>{
                    return(
                      <NavDropdown.Item key={index} as={Link} to={'/geschaeftsadresse/'+item?.city?.key}>
                        {" "}
                        {item?.city?.name}
                      </NavDropdown.Item>
                    )
                  })}
                  
                  <NavDropdown.Item as={Link} to="/standorte">
                    {" "}
                    {t('navbar:link_3_dropdown_1')}
                  </NavDropdown.Item>
                  
                </NavDropdown>

                <Link to="/dubai">{t('navbar:link_4')}</Link>
                <Link to="/raeume">{t('navbar:link_5')}</Link>
                <Link to="/blog">{t('navbar:link_6')}</Link>
                <Link to="/preise">{t('navbar:link_7')}</Link>
                <Link to="/ueber-uns">{t('navbar:link_8')}</Link>
              </Nav>
            </Navbar.Collapse>

            <div className="MainHrDrop">
              <Dropdown className="MainHrDropItem country-dropdown">
                <Dropdown.Toggle variant="" id="dropdown-en" title="Language">                  
                  {hostLanguage === "de" ? (
                    <Image src="/images/flags/flag-of-switzerland.png" width={32} height={32} alt="Deutsch"/>
                  ) : hostLanguage === "en" ? (
                    <Image src="/images/flags/flag-of-usa.png" width={32} height={32} alt="English"/>
                  ) : hostLanguage === "es" ? (
                    <Image src="/images/flags/flag_of_spain.png" width={32} height={32} alt="Español" />
                  ) : hostLanguage === "fa" ? (
                    <Image src="/images/flags/flag_of_iran.png" width={32} height={32} alt="فارسی" />
                  ) : hostLanguage === "fr" ? (
                    <Image src="/images/flags/flag_of_france.png" width={32} height={32} alt="Français"/>
                  ) : hostLanguage === "pt" ? (
                    <Image src="/images/flags/flag_of_portugal.png" width={32} height={32} alt="Português"/>
                  ) : hostLanguage === "ru" ? (
                    <Image src="/images/flags/flag_of_russia.png" width={32} height={32} alt="Русский"/>
                  ) : hostLanguage === "tr" ? (
                    <Image src="/images/flags/flag_of_turkey.png" width={32} height={32} alt="Türkçe"/>
                  ) : hostLanguage === "zh" ? (
                    <Image src="/images/flags/flag_of_china.png" width={32} height={32} alt="中國人"/>
                  ) : (
                    ""
                  )}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {language?.map((item, index) => {
                    return (
                      <Dropdown.Item 
                        key={index}
                        title={item?.language}
                        as={Link}
                        onClick={(e) => {
                          changeLanguage(item?.short_name);
                          setHostLanguage(item?.short_name);
                        }}
                      >
                        {item?.short_name === "de" ? (
                          <Image src="/images/flags/flag-of-switzerland.png" width={32} height={32} alt="German flag – Select German language for CleverDomizil" />
                        ) : item?.short_name === "en" ? (
                          <Image src="/images/flags/flag-of-usa.png" width={32} height={32} alt="United States flag – Select English language for CleverDomizil" />
                        ) : item?.short_name === "es" ? (
                          <Image src="/images/flags/flag_of_spain.png" width={32} height={32} alt="Spanish flag – Seleccione el idioma Español en CleverDomizil" />
                        ) : item?.short_name === "fa" ? (
                          <Image src="/images/flags/flag_of_iran.png" width={32} height={32} alt="Iranian flag – انتخاب زبان فارسی برای CleverDomizil" />
                        ) : item?.short_name === "fr" ? (
                          <Image src="/images/flags/flag_of_france.png" width={32} height={32} alt="French flag – Sélectionnez la langue Française sur CleverDomizil" />
                        ) : item?.short_name === "pt" ? (
                          <Image src="/images/flags/flag_of_portugal.png" width={32} height={32} alt="Portuguese flag – Selecionar idioma Português para CleverDomizil" />
                        ) : item?.short_name === "ru" ? (
                          <Image src="/images/flags/flag_of_russia.png" width={32} height={32} alt="Russian flag – Выберите Русский язык для CleverDomizil" />
                        ) : item?.short_name === "tr" ? (
                          <Image src="/images/flags/flag_of_turkey.png" width={32} height={32} alt="Turkish flag – Türkçe dilini CleverDomizil için seçin" />
                        ) : item?.short_name === "zh" ? (
                          <Image src="/images/flags/flag_of_china.png" width={32} height={32} alt="Chinese flag – 选择中文语言用于 CleverDomizil" />
                        ) : (
                          <Image src="/images/flags/flag-of-switzerland.png" width={32} height={32} alt="Flag icon for language selection" />
                        )}
                          <br />
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="MainHrLftBtnGrp">
              {userData !== undefined && userData !== null ? (
                <>
                  {userData?.role === "client" ? (
                    <>
                      <Button variant="primary" type="button" className="LogBtn" onClick={() => navigate("/LetStarted")}>
                        {t('navbar:account.book')}
                      </Button>

                      <Button variant="primary" type="button" className="RegBtn" onClick={() => navigate("/AccountSettings")}>
                        {t('navbar:account.account')}
                      </Button>
                    </>
                  ) : userData?.role === "student" && userData?.upload_file === 1 ? (
                    <Button variant="primary" type="button" className="RegBtn" onClick={() => navigate("/student-dashboard")}>
                      {t('navbar:account.dashboard')}
                    </Button>
                  ) : userData?.role === "student" && userData?.upload_file === 0 ? (
                    <Button variant="primary" type="button" className="RegBtn" onClick={() => navigate("/student-account-set-up")}>
                      {t('navbar:account.account')}
                    </Button>
                  ) : null}
                </>
              ) : (
                <>
                  <Button variant="primary" type="button" className="LogBtn" onClick={() => navigate("/Login")}>
                    {t('navbar:account.login')}
                  </Button>

                  <Button variant="primary" type="button" className="RegBtn" onClick={() => navigate("/register")}>
                    {t('navbar:account.register')}
                  </Button>
                </>
              )}
            </div>
          </div>
        </Container>
      </Navbar>
    </div>
  );
};

export default Mainheader;
